export default class InvalidEnvironmentVariableError extends Error {
    constructor(env: string) {
        super(`${env} environment variable is not the correct type`);
    }
}
